/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Component, ViewEncapsulation, Input, ViewChild, ElementRef } from '@angular/core';
import { NotificationService, Type } from '@progress/kendo-angular-notification';
import { DialogService, DialogCloseResult, DialogRef } from '@progress/kendo-angular-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from '../services/loading.service';
import { NotificationType } from '../services/Utility.Service';

@Component({
  selector: 'app-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NotifierComponent {
  public errorText: string;
  public errorTitle: string;
  public errorSrc: SafeResourceUrl;
  public windowContent;
  public dialogWindowOpened: boolean = false;



  constructor(private notificationService: NotificationService, private dialogService: DialogService,
    private sanitizer: DomSanitizer, private http: HttpClient, private loadingService: LoadingService) {
  }


  public ShowNotifier(type: NotificationType, title: string, text: string) {
    let notifier: DialogRef = this.dialogService.open({
      title: title,
      content: text,
      width: 350
    });
    let iconClass: string = type == NotificationType.NOTIFIER_ERROR ? "k-i-warning" : "k-i-success";
    setTimeout(() => {
      if (title) {
        let titlebar: any = notifier.dialog.instance.titlebarView.first;
        if (type == NotificationType.NOTIFIER_ERROR) {
          titlebar.hostElement.nativeElement.classList.add("bg-danger");
        }
        let iconSpan: HTMLSpanElement = document.createElement("span");
        iconSpan.classList.add("k-icon", iconClass, "pr-2");
        titlebar.hostElement.nativeElement.prepend(iconSpan);
      }
    }, 0);
    setTimeout(() => {
      notifier.close();
    }, (type as number))

  }

  public ShowNotification(errorTest: string, notifyType: Type['style']): void {
    this.notificationService.show({
      content: errorTest,
      //cssClass: 'button-notification',      
      hideAfter: 10000,
      position: { horizontal: 'center', vertical: 'top' },
      animation: { type: 'fade', duration: 400 },
      type: { style: notifyType, icon: true },
    });
    this.HideLoadingDiv("projDialogLoadingDiv");
    this.loadingService.ShowLoading.next(false);

  }

  public HideLoadingDiv(id: string) {
    if (document.getElementById(id)) {
      (document.getElementById(id)).style.display = 'none';
    }
  }

  public ShowWindowNotification(errTitle: string, errorMessage: string, url: string = null) {
    if (this.dialogWindowOpened == false) {
      this.errorSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url)
      this.errorText = errorMessage;
      this.errorTitle = errTitle;
      this.windowContent = this.dialogService.open({
        title: errTitle,
        content: errorMessage,
        height: 200,
        width: 500,
      }).result.subscribe(result => {
        if (result instanceof DialogCloseResult) {
          this.dialogWindowOpened = false;
        }
      });
      this.dialogWindowOpened = true
    }
    this.HideLoadingDiv("projDialogLoadingDiv");
    this.loadingService.ShowLoading.next(false);
  }
}
